<template>
  <section class="content-welcome">
    <div class="content-welcome-itens">
      <div class="content-welcome-itens--information">
        <div class="content-date">
          <div class="content-date--image">
            <img
              class="img-fluid"
              src="@/assets/img/icon-calendar.png"
              alt="icon calender"
              title="icon calendar"
            />
          </div>
          <p>{{ date }}</p>
        </div>
        <div class="content--name-project">
          <p>Desenvolvimento Pessoal</p>
        </div>
      </div>
      <div class="content-welcome-itens--text">
        <div class="title">
          <h1>
            Olá, Seja Bem Vindo, <span>{{ user?.name }}.</span>
          </h1>
          <img
            class="img-fluid"
            src="@/assets/img/emoji-feliz.png"
            alt="emoji feliz"
            title="emoji feliz"
          />
        </div>
        <div class="subtitle">
          <h2>Estamos muito felizes em ter você com a gente.</h2>
          <img
            class="img-fluid"
            src="@/assets/img/emoji-aperto-de-mao.png"
            alt="emoji aperto de mao"
            title="emoji aperto de mao"
          />
        </div>
      </div>
      <div class="content-welcome-itens--other-text">
        <p>
          Para acessar todos os recursos do sistema,
          <span>basta clicar no menu lateral a esquerda.</span>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("User", ["user"]),
    date() {
      const date = new Date();
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let month = date.getMonth();
      let year = date.getFullYear();
      let arrayNameMonth = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ];
      let nameMonth = arrayNameMonth[month];

      return `Dia ${day} de ${nameMonth} de ${year}`;
    },
  },
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
